export const getValuesWithout = (array, substring) => (
  array.filter((i) => !String(i.value).includes(substring))
);

export const getValuesContaining = (array, substring) => (
  array.filter((i) => String(i.value).includes(substring))
);

export const filterOutDuplicateObjects = (array, value) => (
  array.filter((i) => String(i.value) !== value)
);

export const orderByStartDate = (array) => {
  const nullStartDate = array.filter((i) => i.start_date === null);
  return array.filter((i) => i.start_date !== null).sort((a, b) => {
    const aDateArray = a.start_date.split('-').map((x) => Number(x));
    const bDateArray = b.start_date.split('-').map((x) => Number(x));
    // Subtracted 1 to get the correct month;
    const aDate = new Date(aDateArray[0], aDateArray[1] - 1, aDateArray[2]);
    const bDate = new Date(bDateArray[0], bDateArray[1] - 1, bDateArray[2]);
    return bDate - aDate;
  }).concat(nullStartDate);
};

export const sum = (lineItems, isEmployer) => {
  if (lineItems) {
    if (isEmployer) {
      return lineItems.reduce((s, lineItem) => s + (lineItem.gross_total || 0), 0);
    }
    return lineItems.reduce((s, lineItem) => s + (lineItem.total || 0), 0);
  }
  return 0;
};

export const sumTime = (lineItems) => {
  if (lineItems && lineItems.length > 0) {
    let hours = lineItems.reduce((s, lineItem) => s + lineItem.hours, 0);
    let minutes = lineItems.reduce((s, lineItem) => s + lineItem.minutes, 0);
    if (minutes >= 60) {
      hours += parseInt(minutes / 60, 10);
      minutes %= 60;
    }
    const total = { hours, minutes };
    return total;
  }
  return { hours: 0, minutes: 0 };
};
